import { render, staticRenderFns } from "./CompanyExpansion.vue?vue&type=template&id=62f9bcdd"
import script from "./CompanyExpansion.vue?vue&type=script&lang=js"
export * from "./CompanyExpansion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports